(() => {
  const productField = document.querySelector('#GGContactProduct');
  const productPath = new URLSearchParams(location.search).get('product');
  if (productField && !productField.value && productPath) {
    try {
      const productUrl = new URL(productPath, location.origin);
      if (productUrl.origin === location.origin && productUrl.pathname.startsWith('/products/')) productField.value = productUrl.href;
    } catch {}
  }
  const status = document.querySelector('.gg-contact [data-gg-contact-status]');
  if (!status) return;
  const showStatus = () => requestAnimationFrame(() => {
    status.focus({ preventScroll: true });
    status.scrollIntoView({ block: 'center', behavior: 'instant' });
  });
  if (document.readyState === 'complete') showStatus();
  else window.addEventListener('pageshow', showStatus, { once: true });
})();
